site.optionImages = {
	init: function () {
		$('option', 'select.optionImages').each(function() {
			var $this = $(this);
			var $filenameAndLabel = $this.text().split('~');
			if ($filenameAndLabel.length > 1) {
				$this.attr('data-image', '/static/strevda/xs/' + $filenameAndLabel[0]);
				$this.text($filenameAndLabel[1]);
			}
		});

		try {
			$('select.optionImages').msDropDown();
		} catch(e) {
			console.log(e.message);
		}
	}
};